module.exports = __webpack_public_path__ + "static/media/13.c5b1b6a0.svg";